import { render } from "./SearchForm.vue?vue&type=template&id=57396e4a"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/etl/etl/outerspace-admin-2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__